import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Avoj venkis. Kaj ni nur konsumis venkaĵon.<br/>
        Kio restis? Ĉu restis ja io por ni?<br/>
        Ĉu ne mem ni surtretis kun rido la braĝon<br/>
        Por alvenu kun morn’ kaj mallum’ agoni’?
      </p>

      <p class="poem-block mb-3">
        Ĉu ne mem ni estingis la torĉon de gloro?<br/>
        Ĉu ne kaŭris en hont’ antaŭ eksa venkit’?<br/>
        Do akceptu la signojn de la malhonoro:<br/>
        En la vivo mizera – mizera spirit’.
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Avoj venkis'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;